export function containsHTML(value) {
  const htmlTagRegex = /<[^>]+>/g;
  if (typeof value === "string") {
    return htmlTagRegex.test(value);
  }
  if (Array.isArray(value)) {
    return value.some((item) => typeof item === "string" && htmlTagRegex.test(item));
  }
  return false;
}

export function createMarkup(content) {
  return { __html: content };
}

export function isNotEmpty(value) {
  if (value === null || value === undefined) return false;

  if (typeof value === "string") {
    return value.trim() !== "";
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === "object") {
    return Object.keys(value).length > 0;
  }

  return true;
}


  export function getCookie(name) {
    var cookieName = name + "=";
    var cookieArray = document.cookie.split(";");
    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return "";
  }
  export function setCookie(name, value, hours) {
    var expires = "";
    if (hours > 0) {
      var expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + hours * 60 * 60 * 1000);
      expires = "expires=" + expirationDate.toUTCString();
    } else {
      // force cookie removal
      expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
    }
    document.cookie = name + "=" + value + "; " + expires + "; path=/";
  }